import * as actionTypes from "../ActionTypes";

const initialState = {
  transfersData: [],
};

const store = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_TRANSFER_INIT:
      return {
        ...state,
      };
    case actionTypes.GET_TRANSFER_SUCCESS:
      return {
        ...state,
        transfersData: action.payload,
      };
    case actionTypes.GET_TRANSFER_FAIL:
      return {
        ...state,
        error: "",
      };

    default:
      return state;
  }
};

export default store;
